// import layoutHelpers from '@/layout/helpers.js'
import Vue from 'vue'
import moment from 'moment'
import {AUTH_SIGNOUT} from './store/actions/auth'
// import * as numeral from 'numeral'
var numeral = require('numeral');

export default {
  data() {
    return {
      
    };
  },
  computed: {
    /*
    showDocs () {
      return this.$store.state.user.profile.name
    }
    */
    isAuthenticated () {
      return this.$store.state.auth.isAuthenticated
    }
  },
  methods: {
    
    syncLogout () {
      // console.log('syncLogout () status: ' + this.$store.state.auth.status)
      if (event.key === 'duppla_signout' && this.$store.state.auth.status !== 'signout') {
        this.$store.dispatch(AUTH_SIGNOUT).then(() => { this.$router.push({ name: 'signout'}) })
      }
    },
    gTrackEvent (action, category, label, value = null) {
      //console.log('gTag Event action: ' + action + " category: " + category + " label: " + label)
      try{
        this.$gtag.event(action, {
          'event_category': category,
          'event_label': label,
          'value': value
        })
      } catch (e) {
        console.error('gTrackEvent error:')
        console.error(e)
      }
    },
    gTrackException (description, fatal = false) {
      console.error(description)
      try{
        this.$gtag.exception({
          'description': description,
          'fatal': fatal
        })
      } catch (e) {
        console.error('gTrackException error:')
        console.error(e)
      }
    },
    /*
    hasAnyRole (roles) {
      if (roles) {
        if (this.$store.state.user.status === 'authenticated') {
          for (var i = 0; i < roles.length; i++) {
            if (this.$store.state.user.profile.authorityCollection.some(item => item.authorityId === roles[i])) {
              return true
            }
          }
        } else {
          return false
        }
      }
      return false
    },
    */
    /*
    roundDecimals (value, decimals) {
      return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals)
    },
    */
    hideModal (id) {
      this.$root.$emit('bv::hide::modal', id)
    },
    showModal (id) {
      this.$root.$emit('bv::show::modal', id)
    },
    /*
    toastError (message, duration = 5000) {
      message = '<i class="ion ion-md-close mr-2"></i> <strong>' + message + '</strong>'
      const className = 'bg-danger text-white font-weight-bold'
      this.toast(message, duration, className)
    },
    toastWarn (message, duration = 5000) {
      message = '<i class="ion ion-md-warning mr-2"></i> <strong>' + message + '</strong>'
      const className = 'bg-warning text-dark'
      this.toast(message, duration, className)
    },
    toastSuccess (message, duration = 5000) {
      message = '<i class="ion ion-md-checkmark mr-2"></i> <strong>' + message + '</strong>'
      const className = 'bg-success text-white font-weight-bold'
      this.toast(message, duration, className)
    },
    toast (message, duration, className) {
      try {
        Vue.toasted.clear()
        Vue.toasted.show(message, {
          theme: 'bubble',
          position: 'top-right',
          className: className,
          duration: duration,
          singleton: true,
          keepOnHover: true
        })
      } catch (e) {
        console.error('Trying to display message: ' + message)
        console.error(e)
      }
    },
    */
    humanFileSize (size) {
      //SI
      var i = size == 0 ? 0 : Math.floor( Math.log(size) / Math.log(1000) );
      return ( size / Math.pow(1000, i) ).toFixed(0) * 1 + ' ' + ['bytes', 'KB', 'MB', 'GB', 'TB'][i];
    },
    formatDate (value, format = 'DD/MM/YYYY  H:mm') {
      return moment(value).format(format)
    },
    formatCurrencyNumber (value) {
      return numeral(value).format('0,0.00')
    },
    formatCurrency (value, prepend = '$') {
      return numeral(value).format(prepend + '0,0.00')
    },
    convertNumber (value) {
      return Number(numeral(value).format('0.00'))
    },
    round (n, digits = 0) {
      var negative = false
      if (n < 0) {
        negative = true
        n = n * -1
      }
      var multiplicator = Math.pow(10, digits)
      n = parseFloat((n * multiplicator).toFixed(11))
      n = (Math.round(n) / multiplicator).toFixed(digits)
      if (negative) {
        n = (n * -1).toFixed(digits)
      }
      return Number(n)
    },
    pad (num, size) {
      let s = num + ''
      while (s.length < size) s = '0' + s
      return s
    },
    generateRandomNumber (length) {
      return Math.floor(Math.pow(10, length - 1) + Math.random() * 9 * Math.pow(10, length - 1))
    },
    /*
    sortCompareAdvanced (a, b, key) {
      var flatten = require('flat')
      if (typeof a[key] === 'number' && typeof b[key] === 'number') {
        // If both compared fields are native numbers
        return a[key] < b[key] ? -1 : (a[key] > b[key] ? 1 : 0)
      } else {
        if (flatten(a).hasOwnProperty(key) && flatten(b).hasOwnProperty(key)) {
          // Stringify the field data and use String.localeCompare
          return (flatten(a)[key]).toString().localeCompare((flatten(b)[key]).toString(), undefined, {
            numeric: true
          })
        } else {
          if (flatten(a).hasOwnProperty(key) && !flatten(b).hasOwnProperty(key)) {
            return -1
          }
          return 1
        }
      }
    },
    objectDeepKeys (obj) {
      var keys = []
      for (var key in obj) {
        keys.push(key)
        if (typeof obj[key] === 'object') {
          var subkeys = this.objectDeepKeys(obj[key])
          keys = keys.concat(subkeys.map(function (subkey) {
            return key + '.' + subkey
          }))
        }
      }
      return keys
    },
    */
    whatsappLink(source, text, phoneNumber = '+5214151770622') {
      let url = "https://api.whatsapp.com/send";
      if (this.isMobile()) {
        url = "whatsapp://send";
      }
      const all = url + "?phone=" + phoneNumber + "&text=" + text;
      window.open(all, "_blank");
      this.gTrackEvent('generate_lead', 'engagement', source)
    },
    isMobile() {
      var check = false;
      (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
      return check;
    }
  }
}
